export type LayerMove = 'forward' | 'backward' | 'front' | 'back';

/** Canonical state order is back-to-front, identical to canvas paint order. */
export function reorderLayers<T extends { id: string }>(layers: readonly T[], id: string, action: LayerMove): T[] {
  const result = [...layers];
  const index = result.findIndex((layer) => layer.id === id);
  if (index < 0) return result;
  const [layer] = result.splice(index, 1);
  let target = index;
  if (action === 'forward') target = Math.min(result.length, index + 1);
  if (action === 'backward') target = Math.max(0, index - 1);
  if (action === 'front') target = result.length;
  if (action === 'back') target = 0;
  result.splice(target, 0, layer);
  return result;
}

/** UI lists and hit-testing inspect the front-most layer first. */
export function frontToBack<T>(layers: readonly T[]): T[] { return [...layers].reverse(); }
